<div *ngIf="showSearch" id="myOverlay" class="overlay" [ngClass]="{ scroll: scrolled }">
	<div class="overlay-content">
		<form [formGroup]="searchForm" action="">
			<input type="text" class="form-control" placeholder="Pesquisar..." formControlName="search" />
			<button class="btn btn-primary" (click)="goSearch()"><i class="fa fa-search"></i></button>
			<button class="btn btn-light" (click)="switchSearch()"><i class="fa fa-times"></i></button>
		</form>
	</div>
</div>
